/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PricingRateItem {
    getFixupPrototypeFunction() { return PricingRateItem.fixupPrototype; }

    static newInstance(model: Partial<PricingRateItem>): PricingRateItem {
        let obj = Object.assign(new PricingRateItem(), model);
        PricingRateItem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PricingRateItem>): PricingRateItem {
        if (!model) return null;
        return PricingRateItem.newInstance(<PricingRateItem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PricingRateItem) {
        if (!obj) return;

        models.PricingRateItem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PricingRateItem): boolean {
        Object.setPrototypeOf(obj, PricingRateItem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ON_DEMAND | RESERVED | SAVINGS_PLAN | SPOT
     */
    pricing_type: string;

    /**
     * NO_UPFRONT | PARTIAL_UPFRONT | ALL_UPFRONT — RESERVED only
     */
    payment_option: string;

    /**
     * 1yr | 3yr — RESERVED only
     */
    commitment_term: string;

    /**
     * Hourly rate as a string Decimal (e.g. \"0.1920000000\")
     */
    price: string;

    /**
     * One-time upfront fee for RESERVED pricing
     */
    upfront_cost: string;

    /**
     * On-demand baseline rate — populated on RESERVED docs after backfill
     */
    on_demand_rate: string;

    /**
     * ISO 8601 date the rate became effective
     */
    effective_date: string;

    /**
     * Human-readable rate description from AWS
     */
    description: string;

}
